/* eslint-disable import/prefer-default-export */
export const mixpanelEvents = {
  ADD_SERVICE_SERVICES_MODULE: 'Add Service_Services Module',
  SAVE_SERVICE_SERVICES_MODULE: 'Save Service_Services Module',
  VIEW_SERVICES_SEARCH: 'View Services_Search',
};
